import script from "./OldSqmComplaintList.vue?vue&type=script&setup=true&lang=js"
export * from "./OldSqmComplaintList.vue?vue&type=script&setup=true&lang=js"

import "./OldSqmComplaintList.vue?vue&type=style&index=0&id=7ab632f6&lang=scss"

const __exports__ = script;

export default __exports__